export const initialTableInfos = {
	tier: '',
	numberOfSeats: '',
	amount: '',
	price: '',
	fairMarketValue: '',
	displayRemainingTickets: false,
	remainingTicketsThresholdValue: 0,
	isTicketsVisibleOnAuction: true,
	privatePurchaseUrl: null,
};

export const initialRaffleTires = {numberOfTickets: null, price: 0};
